import { Component, Input } from 'ng-metadata/core';

import './footer.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentFooter
 * @module mw.components.contentDocuments
 *
 * @description
 * `<mw-content-document-footer>` is a component used to represent the footer of a content document component.
 *  it has support for trigger components and a sentiment component.
 * @usage
 * <hljs hljs-language="html">
 * <mw-content-document-footer>
 *  <mw-content-document-action-trigger></mw-content-document-action-trigger>
 *  <mw-content-document-action-trigger></mw-content-document-action-trigger>
 *  <mw-content-document-action-trigger></mw-content-document-action-trigger>
 *  <mw-content-document-sentiment> </mw-content-document-sentiment>
 * </mw-content-document-footer>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-footer',
    template: `
        <div layout="row" class="mw-content-document-footer">
            <ng-transclude ng-transclude-slot="mwContentDocumentActionTriggers" flex="noshrink" class="mw-content-document-footer__triggers"></ng-transclude>
            <div flex="100"><ng-transclude></ng-transclude></div>
            <ng-transclude ng-transclude-slot="mwContentDocumentSentiment" flex="noshrink" class="mw-content-document-footer__sentiment"></ng-transclude>
        </div>
    `,
    legacy: {
        transclude: {
            mwContentDocumentActionTriggers: '?mwContentDocumentActionTrigger',
            mwContentDocumentSentiment: '?mwContentDocumentSentiment'
        }
    }
})
export class FooterComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/footer/footer.component.ts